/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import React, { useState, useCallback } from 'react';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { createUrl } from '../../redux/helper/CreateQuery';

function SubscribersFilterModal({
    filterModal, setFilterModal, setFilter, Filter, handleFilter, handleFetchBulkOfferSubscribers, setfilterValue,
}) {
    const [selectedType, setselectedType] = useState('status');

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateFilterQuery = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'status':
                if (Filter[key].length > 0) {
                    final += `status=${createUrl(Filter[key])}`;
                }
                break;
            case 'type':
                if (Filter[key].length > 0) {
                    final += `industrial_pocket=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
            return final;
        });
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        return final;
    };

    const handleClear = () => {
        setFilter({
            status: [],
            type: [],
        });
        setfilterValue('');
        handleFetchBulkOfferSubscribers();
        setFilterModal(false);
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? '' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[532px] min-w-[532px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[50%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start mb-4" role="presentation" onClick={() => setselectedType('status')}>
                                    <a
                                        href="#pills-pricetab"
                                        className={`nav-link block text-base font-semibold ${selectedType === 'status' ? 'active' : ''} text-[#AAA6AF] order relative w-full`}
                                        id="pills-priceranje"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pricetab"
                                        role="tab"
                                        aria-controls="pills-price"
                                        aria-selected="true"
                                    >
                                        Status
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('type')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block ${selectedType === 'type' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-categories"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pillcategorie"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Type
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane ${selectedType === 'status' ? 'show active' : ''} fade px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="flex items-center">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.status?.includes('0') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.status?.includes('0')}
                                                onChange={() => HandleFilter('status', '0')}
                                                borderColor={`${Filter.status?.includes('0') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                id="status"
                                            />
                                            <label htmlFor="status" className="consumbales pl-3 text-xs14 font-normal text-[#090406] text-left cursor-pointer">Inactive</label>
                                        </div>
                                        <div className="relative flex items-center mt-[14px]">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.status?.includes('1') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.status?.includes('1')}
                                                onChange={() => HandleFilter('status', '1')}
                                                borderColor={`${Filter.status?.includes('1') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                id="mn16"
                                            />
                                            <label htmlFor="mn16" className="consumbales pl-3 text-xs14 font-normal text-[#090406] text-left cursor-pointer">Active</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'type' ? 'show active' : ''} fade px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className="relative">
                                        <div className="relative flex items-center">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('ALL') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('ALL')}
                                                onChange={() => HandleFilter('type', 'ALL')}
                                                borderColor={`${Filter.type?.includes('ALL') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                id="mn17"
                                            />
                                            <label htmlFor="mn17" className="consumbales pl-3 text-xs14 font-normal text-[#090406] text-left cursor-pointer">ALL</label>
                                        </div>
                                        <div className="relative flex items-center mt-[14px]">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('HIP') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('HIP')}
                                                onChange={() => HandleFilter('type', 'HIP')}
                                                borderColor={`${Filter.type?.includes('HIP') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                id="mn18"
                                            />
                                            <label htmlFor="mn18" className="consumbales pl-3 text-xs14 font-normal text-[#090406] text-left cursor-pointer">HIP</label>
                                        </div>
                                        <div className="relative flex items-center mt-[14px]">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('MIP') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('MIP')}
                                                onChange={() => HandleFilter('type', 'MIP')}
                                                borderColor={`${Filter.type?.includes('MIP') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                id="mn19"
                                            />
                                            <label htmlFor="mn19" className="consumbales pl-3 text-xs14 font-normal text-[#090406] text-left cursor-pointer">MIP</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[50%] mr-5">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubscribersFilterModal;
